import { createFileRoute } from '@tanstack/react-router';
import { NotionCallbackPage } from '@/containers/integrations/google-callback-page.component';

export const Route = createFileRoute('/integrations/notion/callback')({
  component: NotionCallbackPage,
});
